import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  fg: {
    display: "flex",
    width: "100%",
    height: "100%",
  },
  leftPart: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    height: "calc(100vh - 64px)",
    zIndex: 10,
  },
  rightPart: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    height: "calc(90vh - 64px)",
    marginTop: "10vh",
    "& img": {
      height: "60%",
      backgroundPosition: "bottom right",
    },
  },
  capital: {
    fontSize: 22,
    fontWeight: "bold",
    marginTop: theme.spacing(1),
    marginBottom: 4,
    color: theme.palette.text.hint,
  },
  title: {
    fontSize: 64,
    fontWeight: 500,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(5),
    color: "#fff",
  },
  content: {
    fontSize: 16,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));